import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

function AddIngredientForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const { id } = useParams();
  const [formData, setFormData] = useState({
    code: "",
    name: "",
    user_id: user?.user.id,
    category_id: "",
    category_name: "",
    purchase_price: "",
    vat_percentage: 0,
    tax_method: "",
    ing_vat: "",
    total_amount: 0,
    alert_quantity: "",
    unit_id: "",
    unit_name: "",
    outlet_id: user?.user.outlet_id,
  });
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isTaxDisable, setIsTaxDisable] = useState(false);
  const [categoryOptions, setCategryOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [vatOptions, setVatOptions] = useState([]);

  const taxOptions = [
    {
      value: "no tax",
      label: "No Tax",
    },
    {
      value: "inclusive",
      label: "Inclusive",
    },
    {
      value: "exclusive",
      label: "Exclusive",
    },
  ];

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const postData = (csrfToken) => {
      if (!id) {
        axios
          .post(`${apiKey}/api/rms/admin/ingredients`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            setFormData({
              code: "",
              name: "",
              user_id: user?.user.id,
              category_id: "",
              category_name: "",
              purchase_price: "",
              vat_percentage: 0,
              tax_method: "",
              ing_vat: "",
              total_amount: 0,
              alert_quantity: "",
              unit_id: "",
              unit_name: "",
              outlet_id: user?.user.outlet_id,
            });
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            toast.error(err.response.data.message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        axios
          .put(`${apiKey}/api/rms/admin/ingredients/${id}`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            toast.error(err.response.data.message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    };
    handleCSRF(postData);
  };

  useEffect(() => {
    let vatAmt = 0;
    let purchaseUnitPrice = 0;

    if (formData.tax_method === "no tax") {
      purchaseUnitPrice = formData.purchase_price;
    } else if (formData.tax_method === "inclusive") {
      vatAmt =
        formData.purchase_price -
        formData.purchase_price / (1 + formData.vat_percentage / 100);
      purchaseUnitPrice = formData.purchase_price - 0;
    } else if (formData.tax_method === "exclusive") {
      purchaseUnitPrice =
        formData.purchase_price * (1 + formData.vat_percentage / 100);
      vatAmt = purchaseUnitPrice - formData.purchase_price;
    }

    setFormData((prev) => ({
      ...prev,
      ing_vat: vatAmt.toFixed(2),
      // total_amount: (parseFloat(purchaseUnitPrice) || 0).toFixed(2),
      total_amount: purchaseUnitPrice,
    }));
  }, [formData.vat_percentage, formData.purchase_price, formData.tax_method]);

  useEffect(() => {
    if (formData.tax_method === "No Tax") {
      setIsTaxDisable(true);
    } else {
      setIsTaxDisable(false);
    }
  }, [formData.tax_method]);

  useEffect(() => {
    const fetchData = (csrfToken) => {
      axios
        .get(`${apiKey}/api/rms/admin/ingredientCategories`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          params: {
            outletId: user?.user.outlet_id,
          },
        })
        .then((res) => {
          let mappedOptions = [];
          res.data.forEach((option) =>
            mappedOptions.push({
              value: option.id,
              label: option.category_name,
            })
          );
          setCategryOptions(mappedOptions);
        })
        .catch((err) => {
          console.error(err);
        });
      axios
        .get(`${apiKey}/api/rms/admin/ingredientUnits`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          params: {
            outletId: user?.user.outlet_id,
          },
        })
        .then((res) => {
          let mappedOptions = [];
          res.data.forEach((option) =>
            mappedOptions.push({ value: option.id, label: option.unit_name })
          );
          setUnitOptions(mappedOptions);
        })
        .catch((err) => {
          console.error(err);
        });
      axios
        .get(`${apiKey}/api/rms/admin/vats`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          params: {
            outletId: user?.user.outlet_id,
          },
        })
        .then((res) => {
          let mappedOptions = [];
          res.data.forEach((option) =>
            mappedOptions.push({
              value: option.percentage,
              label: option.percentage,
            })
          );
          setVatOptions(mappedOptions);
        })
        .catch((err) => {
          console.error(err);
        });
    };
    handleCSRF(fetchData);

    if (id) {
      const fetchFormData = (csrfToken) => {
        setPageLoading(true);
        axios
          .get(`${apiKey}/api/rms/admin/ingredients/${id}`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            setFormData(res.data);
          })
          .catch((err) => {
            setError(err.response.data.message);
          })
          .finally(() => setPageLoading(false));
      };
      handleCSRF(fetchFormData);
    }
  }, [user?.token, id, user?.user.outlet_id]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        {error && (
          <div
            className="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
            role="alert"
          >
            <svg
              className="flex-shrink-0 inline w-4 h-4 me-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <span className="sr-only">Info</span>
            <div>{error}</div>
          </div>
        )}
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Add Ingredient")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="grid lg:grid-cols-3 gap-x-8 gap-y-2 w-full">
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Name")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Name")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Alert Qty")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Alert Qty")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="alert_quantity"
                    value={formData.alert_quantity}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Vat Percentage")}
                </span>
                <div className="mb-2 pt-0">
                  {/* <input
                    type="text"
                    placeholder="Vat Percentage"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="vat_percentage"
                    value={formData.vat_percentage}
                    onChange={handleChange}
                    disabled={isTaxDisable}
                  /> */}
                  <Select
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select"
                    options={vatOptions}
                    defaultValue={{
                      value: formData.vat_percentage,
                      label: formData.vat_percentage,
                    }}
                    name="vat_percentage"
                    onChange={(e) =>
                      setFormData({ ...formData, vat_percentage: e.value })
                    }
                    disabled={isTaxDisable}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Category")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={categoryOptions}
                    defaultValue={{
                      label: formData.ingredient_category?.category_name,
                      value: formData.ingredient_category?.id,
                    }}
                    name="category_id"
                    onChange={(e) =>
                      setFormData({ ...formData, category_id: e.value })
                    }
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Unit")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={unitOptions}
                    defaultValue={{
                      value: formData.ingredient_unit?.id,
                      label: formData.ingredient_unit?.unit_name,
                    }}
                    name="unit_id"
                    onChange={(e) =>
                      setFormData({ ...formData, unit_id: e.value })
                    }
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Purchase Unit")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={unitOptions}
                    defaultValue={{
                      value: formData.purchase_ingredient_unit?.id,
                      label: formData.purchase_ingredient_unit?.unit_name,
                    }}
                    name="unit_id"
                    onChange={(e) =>
                      setFormData({ ...formData, purchase_unit_id: e.value })
                    }
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Tax Method")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={taxOptions}
                    defaultValue={{
                      value: formData.tax_method,
                      label:
                        formData.tax_method === "no tax"
                          ? languageHelper("no tax")
                          : formData.tax_method === "inclusive"
                          ? languageHelper("Inclusive")
                          : formData.tax_method === "exclusive"
                          ? languageHelper("Exclusive")
                          : "",
                    }}
                    name="tax_method"
                    onChange={(e) =>
                      setFormData({ ...formData, tax_method: e.value })
                    }
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Purchase Unit Price")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Purchase Unit Price")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="purchase_price"
                    value={formData.purchase_price}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2">
                  {languageHelper("Vat")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Vat")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-200 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full cursor-not-allowed"
                    disabled
                    name="ing_vat"
                    value={formData.ing_vat}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Total Amount with Vat")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Total Amount with Vat")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-200 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full cursor-not-allowed"
                    disabled
                    name="total_amount"
                    value={formData.total_amount || 0}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2">
                  {languageHelper("Code")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Code")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )} */}
    </main>
  );
}

export default AddIngredientForm;
